import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { useOrdersFilterParams } from '../../hooks';
import { cleanOrdersRelationSelectAndStore, getOrdersListRelationSelect } from '../../middleware';
import { OrdersTableList } from './Components';

export const OrdersList: React.FC = observer(() => {
    const filterParams = useOrdersFilterParams();
    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanOrdersRelationSelectAndStore}
                filterParams={filterParams}
                getRelationSelect={getOrdersListRelationSelect}
            >
                <OrdersTableList />
            </ListWrapper>
        </Catcher>
    );
});
